<template>
  <g>
    <path
      d="M19 5.00018C19 3.90018 18.1 3.00018 17 3.00018H15C14.45 3.00018 14 3.45018 14 4.00018C14 4.55018 14.45 5.00018 15 5.00018H17V7.65018L13.52 12.0002H10V8.00018C10 7.45018 9.55 7.00018 9 7.00018H6C3.79 7.00018 2 8.79018 2 11.0002V14.0002H4C4 15.6602 5.34 17.0002 7 17.0002C8.66 17.0002 10 15.6602 10 14.0002H14.48L19 8.35018V5.00018ZM7 15.0002C6.45 15.0002 6 14.5502 6 14.0002H8C8 14.5502 7.55 15.0002 7 15.0002Z"
    />
    <path
      d="M9 4.00018H6C5.45 4.00018 5 4.45018 5 5.00018C5 5.55018 5.45 6.00018 6 6.00018H9C9.55 6.00018 10 5.55018 10 5.00018C10 4.45018 9.55 4.00018 9 4.00018Z"
    />
    <path
      d="M19 11.0002C17.34 11.0002 16 12.3402 16 14.0002C16 15.6602 17.34 17.0002 19 17.0002C20.66 17.0002 22 15.6602 22 14.0002C22 12.3402 20.66 11.0002 19 11.0002ZM19 15.0002C18.45 15.0002 18 14.5502 18 14.0002C18 13.4502 18.45 13.0002 19 13.0002C19.55 13.0002 20 13.4502 20 14.0002C20 14.5502 19.55 15.0002 19 15.0002Z"
    />
    <path d="M7 20.0002H11V18.0002L17 21.0002H13V23.0002L7 20.0002Z" />
  </g>
</template>
